/*
 * $Id:: accountSlice.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { createSlice } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';

export const slice = createSlice({
    name: SLICE_NAME,
    initialState: {
        details: null,
        requestResult: null,
        childAccounts: null,
        selectedChildAccount: null,
        deactivateResult: null,
        authorities: [],
        error: null,
        loading: false,
        loadingUserDetails: false,
        loadingAddress: false,
        loadingContactInfo: false,
        accountLocked: null,
        loadingAccountLockUserDetails: false,
        loadingAccountLockAddress: false,
        loadingAccountLockContactInfo: false,
        loadingAccountLockEditChild: false,
    },
    reducers: {
        details: (state, action) => {
            state.details = action.payload;
        },
        childAccounts: (state, action) => {
            state.childAccounts = action.payload;
        },
        selectedChildAccount: (state, action) => {
            state.selectedChildAccount = action.payload;
        },
        updateLanguage: (state, action) => {
            state.requestResult = action.payload;
            state.profile = { ...state.profile, language: action.payload.language };
        },
        requestResult: (state, action) => {
            state.requestResult = action.payload;
        },
        deactivateResult: (state, action) => {
            state.deactivateResult = action.payload;
        },
        updateAuthorities: (state, action) => {
            state.authorities = action.payload;
        },
        loading: (state, action) => {
            state.loading = action.payload;
        },
        loadingUserDetails: (state, action) => {
            state.loadingUserDetails = action.payload;
        },
        loadingAddress: (state, action) => {
            state.loadingAddress = action.payload;
        },
        loadingContactInfo: (state, action) => {
            state.loadingContactInfo = action.payload;
        },
        error: (state, action) => {
            state.error = action.payload;
        },
        accountLocked: (state, action) => {
            state.accountLocked = action.payload;
        },
        loadingAccountLockUserDetails: (state, action) => {
            state.loadingAccountLockUserDetails = action.payload;
        },
        loadingAccountLockAddress: (state, action) => {
            state.loadingAccountLockAddress = action.payload;
        },
        loadingAccountLockContactInfo: (state, action) => {
            state.loadingAccountLockContactInfo = action.payload;
        },
        loadingAccountLockEditChild: (state, action) => {
            state.loadingAccountLockEditChild = action.payload;
        },
    },
});

export const details = (state) => state[SLICE_NAME].details;
export const requestResult = (state) => state[SLICE_NAME].requestResult;
export const deactivateResult = (state) => state[SLICE_NAME].deactivateResult;
export const childAccounts = (state) => state[SLICE_NAME].childAccounts;
export const selectedChildAccount = (state) => state[SLICE_NAME].selectedChildAccount;
export const authorities = (state) => state[SLICE_NAME].authorities;
export const loading = (state) => state[SLICE_NAME].loading;
export const loadingUserDetails = (state) => state[SLICE_NAME].loadingUserDetails;
export const loadingAddress = (state) => state[SLICE_NAME].loadingAddress;
export const loadingContactInfo = (state) => state[SLICE_NAME].loadingContactInfo;
export const error = (state) => state[SLICE_NAME].error;
export const accountLocked = (state) => state[SLICE_NAME].accountLocked;
export const loadingAccountLockUserDetails = (state) => state[SLICE_NAME].loadingAccountLockUserDetails;
export const loadingAccountLockAddress = (state) => state[SLICE_NAME].loadingAccountLockAddress;
export const loadingAccountLockContactInfo = (state) => state[SLICE_NAME].loadingAccountLockContactInfo;
export const loadingAccountLockEditChild = (state) => state[SLICE_NAME].loadingAccountLockEditChild;
export default slice.reducer;
